var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97508 9.01716L3.5 6.54149L4.32483 5.71666L5.97508 7.36632L9.27442 4.06641L10.0998 4.89182L5.97508 9.01716Z",
    fill: "#16F62C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583984 6.50065C0.583984 2.9569 3.4569 0.0839844 7.00065 0.0839844C10.5444 0.0839844 13.4173 2.9569 13.4173 6.50065C13.4173 10.0444 10.5444 12.9173 7.00065 12.9173C3.4569 12.9173 0.583984 10.0444 0.583984 6.50065ZM7.00065 11.7507C6.31121 11.7507 5.62852 11.6149 4.99156 11.351C4.3546 11.0872 3.77585 10.7005 3.28834 10.213C2.80083 9.72545 2.41412 9.1467 2.15028 8.50974C1.88645 7.87278 1.75065 7.19009 1.75065 6.50065C1.75065 5.81121 1.88645 5.12852 2.15028 4.49156C2.41412 3.8546 2.80083 3.27585 3.28834 2.78834C3.77585 2.30083 4.3546 1.91412 4.99156 1.65028C5.62852 1.38645 6.31121 1.25065 7.00065 1.25065C8.39304 1.25065 9.7284 1.80377 10.713 2.78834C11.6975 3.77291 12.2507 5.10826 12.2507 6.50065C12.2507 7.89304 11.6975 9.2284 10.713 10.213C9.7284 11.1975 8.39304 11.7507 7.00065 11.7507Z",
    fill: "#16F62C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickedCircle);
export default __webpack_public_path__ + "static/media/green_ticked_circle.b3ca4fdb02234dacdde5179815d3b43f.svg";
export { ForwardRef as ReactComponent };